
window.onWizzyScriptLoaded = function () {

  // Replacing default template
  replaceTemplate("wizzy-search-results-product");
  // replaceTemplate("wizzy-search-results");
  // replaceTemplate("wizzy-search-empty-results");
  // replaceTemplate("wizzy-search-wrapper");
  replaceTemplate("wizzy-autocomplete-topproducts");
  // replaceTemplate("wizzy-autocomplete-suggestions");

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      // console.log(payload, "BEFORE_INIT");
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.common.isLazyInit = true;
      if(window.document.documentElement.clientWidth < 1025){
        payload.common.lazyDOMConfig.searchInputIdentifiers = [
          {
              "dom": ".wizzy-search-input-mobile",
              "type": "search"
          }
        ]
      }else {
        payload.common.lazyDOMConfig.searchInputIdentifiers = [
          {
              "dom": ".shopify-section .wizzy-search-input-desktop",
              "type": "search"
          }
        ]
      }
      
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [".main-content"];

      window.WH_TimeOutForCustomButtonsDetection = 1e3;

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      // console.log(payload, "BEFORE_INIT");
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.common.isLazyInit = true;
      if(window.document.documentElement.clientWidth < 1025){
        payload.common.lazyDOMConfig.searchInputIdentifiers = [
          {
              "dom": ".wizzy-search-input-mobile",
              "type": "search"
          }
        ]
      }else {
        payload.common.lazyDOMConfig.searchInputIdentifiers = [
          {
              "dom": ".shopify-section .wizzy-search-input-desktop",
              "type": "search"
          }
        ]
      }
      
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [".main-content"];

      window.WH_TimeOutForCustomButtonsDetection = 1e3;

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED");

      payload.forEach(product => {
        product.reviewPresent = false;
        product.filledStar = "0";
        if(product.attributes){
          product.attributes.forEach(attribute => {
            if(attribute.id === "product_badge_judgeme"){
              if(attribute.values[0].value[0]){
                const reviewEle = window.document.createElement("div");
                reviewEle.innerHTML = attribute.values[0].value[0];
                const reviews = reviewEle.querySelector(".jdgm-prev-badge");
                const averageRating = reviews.getAttribute("data-average-rating");
                const totalReviews = reviews.getAttribute("data-number-of-reviews");
                // console.log(averageRating, "averageRating");
                // console.log(totalReviews, "totalReviews");
                product.avgRatings = averageRating;
                product.totalReviews = totalReviews;
                if(averageRating > 0){
                  // console.log(averageRating);
                  product.reviewPresent = true;
                  product.filledStar = 20*averageRating;
                }
              }
            }
          })
        }
      });

      payload.forEach(product => {
        product.newArrival = false;
         if(product.attributes){
          product.attributes.forEach(attribute => {
            if(attribute.id === "product_tags"){
               if(attribute.values[0].value[0] && attribute.values[0].value[0].includes("NewArrival")){
                 product.newArrival = true;
               }
            }
          })
        }
      });


      if (payload.length == 1) {
        // console.log("Only single product found for this one...");
        setTimeout(function () {
          var selectedFiltersBlock = document.querySelector(
            ".wizzy-selected-filters .wizzy-filters-selected-facets-block"
          );
          if (selectedFiltersBlock) {
            selectedFiltersBlock.style.display = "block";
            selectedFiltersBlock.style.marginTop = "50px";
          }
        }, 200);
      }
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      // payload.minQueryLength = 1;
      return payload;
    }
  );

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      return data;
    })

     window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (payload) {
        // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
        return payload;
      }
    );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_SEARCH_EXECUTED")

      const overlayDesktop = document.getElementById('search-results-overlay-desktop');
      if(overlayDesktop){
        const overlayActiveDesktop = overlayDesktop.classList.contains('active');
        if (overlayActiveDesktop) {
          overlayDesktop.classList.remove('active');
        }
      }

      const overlay = document.getElementById('search-results-overlay-mobile');
      if(overlay){
        const overlayActive = overlay.classList.contains('active');
        if (overlayActive) {
          overlay.classList.remove('active');
        }
      }
      
      return payload;
    }
  );

     window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");

      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log(data," <= VIEW_RENDERED");

      //////////////////////////////////////////////////////////////////////////////////////////////////////////

      const facetBlocks = document.querySelectorAll(
        ".wizzy-filters-facet-block"
      );

      facetBlocks.forEach((facetBlock) => {
        facetBlock.addEventListener("click", () => {
          const isCollapsed = facetBlock.classList.contains("collapsed");

          // Collapse all facet blocks except the clicked one
          facetBlocks.forEach((block) => {
            if (block !== facetBlock) {
              block.classList.add("collapsed");
            }
          });

          // console.log(facetBlock.getAttribute("data-key"), "facetBlock");
          localStorage.setItem('wiz-filter-data-key', facetBlock.getAttribute("data-key"));

          if (isCollapsed) {
            // console.log(isCollapsed,"removed");
            facetBlock.classList.add("collapsed");
          } else {
            // console.log(isCollapsed,"added");
            facetBlock.classList.remove("collapsed");
          }
        });
      });

      ///////////////////////////////////////////////////////////////////////////////////////////////////////////

      const allFacetBlocks = document.querySelectorAll(
        ".wizzy-filters-facet-block"
      );
      allFacetBlocks.forEach((facetBlock) => {
        // console.log("added");
        if(facetBlock.getAttribute("data-key") !== localStorage.getItem('wiz-filter-data-key')){
          // console.log(localStorage.getItem('wiz-filter-data-key'), "Local storage Item");
          facetBlock.classList.add("collapsed");
        }
      });
      localStorage.removeItem('wiz-filter-data-key');

      setTimeout(function () {
        var facetList = document.querySelector(".wizzy-selected-facet-list");

        if (facetList) {
          var existingClearAllLink = facetList.querySelector(
            ".wizzy-filters-clear-all"
          );

          if (!existingClearAllLink) {
            var clearAllLink = document.createElement("a");
            clearAllLink.href = "#";
            clearAllLink.className = "wizzy-filters-clear-all";
            clearAllLink.textContent = "Clear all";

            facetList.appendChild(clearAllLink);
          }
        }
      }, 500);

      /////////////////////////////////////////

      window.WH_TimeOutForCustomButtonsDetection = 500,
        document.querySelectorAll(".wishlist-hero-custom-button").forEach(function(item) {
            var d = new CustomEvent("wishlist-hero-add-to-custom-element",{
                detail: item
            });
            document.dispatchEvent(d)
        });
      
      return data;
    }
  );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      // console.log(payload,"PRODUCTS_CACHED_RESULTS_RENDERED");

      /////////////////////////////////////////

      window.WH_TimeOutForCustomButtonsDetection = 500,
        document.querySelectorAll(".wishlist-hero-custom-button").forEach(function(item) {
            var d = new CustomEvent("wishlist-hero-add-to-custom-element",{
                detail: item
            });
            document.dispatchEvent(d)
        });
    
      return payload;
    }
  );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log(payload,"BEFORE_RENDER_RESULTS");
    
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      return payload;
    }
  );
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};


/////////////////////////////// Muation observer one /////////////////////////////////////////////////


// Select the target element by ID
const target = document.getElementById('search-results-overlay-mobile');

if (target) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const hasActive = target.classList.contains('active');
        
        if (hasActive) {
          document.body.classList.add('wizzy-autocomplete-open');
        } else {
          document.body.classList.remove('wizzy-autocomplete-open');
        }
      }
    }
  });

  // Start observing the target element for attribute changes
  observer.observe(target, {
    attributes: true,
    attributeFilter: ['class']
  });
} else {
  console.warn('Element with ID "#search-results-overlay-mobile" not found.');
}
